import { createSlice } from '@reduxjs/toolkit';

import { handleGetSupplementDetails } from './actions';
import { ISupplementDetailsState } from './slice.interface';

const initialState: ISupplementDetailsState = {
  data: null,
  isLoading: false,
  error: false,
};

export const supplementDetailsSlice = createSlice({
  name: 'supplement-details',
  initialState,
  reducers: {
    removeDietarySupplementDetails: state => {
      state.data = null;
      state.isLoading = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetSupplementDetails.pending, (state: ISupplementDetailsState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetSupplementDetails.rejected, (state: ISupplementDetailsState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetSupplementDetails.fulfilled, (state: ISupplementDetailsState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
      });
  },
});

export const { removeDietarySupplementDetails } = supplementDetailsSlice.actions;

export default supplementDetailsSlice.reducer;
